import { memo } from 'react';
import { usePriceTranslatedPostfix } from '@elfsight/lib-utils';
import { useLingui } from '@lingui/react/macro';
import { TranslateAgnosticPrice } from './translate-agnostic-price';
import type { PriceProps } from './types';

export const Price = memo(
  ({ pricingModel, unit, period, ...forwardingProps }: PriceProps) => {
    const { t } = useLingui();
    const postfix = usePriceTranslatedPostfix(
      pricingModel === 'per' ? unit : period
    );
    const freeLabel = t`Free`;
    const startingAtLabel = t`Starting at`;

    return (
      <TranslateAgnosticPrice
        {...forwardingProps}
        pricingModel={pricingModel}
        freeLabel={freeLabel}
        startingAtLabel={startingAtLabel}
        postfix={postfix}
      />
    );
  }
);
